import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Contact.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;

  const text = `Hi SmartvizX Team 👋

📌 New Website Inquiry

👤 Name: ${name}
📧 Email: ${email}
📱 Phone: ${phone}

💬 Message:
${message}

🕒 Time: ${new Date().toLocaleString()}
🌐 Source: Website Contact Form`;

    const encodedText = encodeURIComponent(text);

    const whatsappNumber = "8527417771"; // your number

    const url = `https://wa.me/${whatsappNumber}?text=${encodedText}`;

    window.open(url, "_blank");
  };

  return (
    <>
      <Navbar />

      {/* HERO/BANNER */}
      <section className="contact-hero">
        <div className="hero-content">
          <h1>Contact Us</h1>
          <p>We’d love to hear from you — here’s how you can reach us.</p>
        </div>
      </section>

      {/* MAIN CONTACT AREA */}
      <main className="contact-section container">
        {/* FORM + INFO ROW */}
        <div className="contact-row">

          {/* FORM */}
          <div className="contact-form-wrapper">
            <h2>Get in Touch</h2>

            <form className="contact-form" onSubmit={handleSubmit}>
              <label>
                <span>Name</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Phone</span>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Message</span>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  onChange={handleChange}
                ></textarea>
              </label>

              <button type="submit" className="contact-btn">
                Send Message
              </button>
            </form>
          </div>

          {/* INFO */}
          <aside className="contact-info-panel">
            <h2>Contact Details</h2>
            <p><strong>Email:</strong> <a href="mailto:info@smartvizx.com">info@smartvizx.com</a></p>
            <p><strong>India Address</strong><br />
              Ofis Square, Tower A1, Unit No. 120, Sector 3,<br />
              Noida, Uttar Pradesh – 201301, India
            </p>
            <p><strong>Phone:</strong> <a href="tel:+918527417771">+91 8527417771</a></p>

            <h3>Dubai Office</h3>
            <p>
              2nd Floor, Business Village Block A,<br />
              Port Saeed, Deira, Dubai
            </p>
          </aside>

        </div>

        {/* MAP (UNCHANGED) */}
        <div className="contact-map">
          <iframe
            title="location map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.625846441709!2d77.31327607628167!3d28.580995975692847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce52fc5e576e5%3A0xc0a4ad0b66eee14f!2sOfis%20Square%20Tower!5e0!3m2!1sen!2sin!4v1763549177149!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default ContactPage;